export { default } from './PageBlogCategories.vue'
